import vue from 'vue'

let dtBegin = new Date()
dtBegin.setDate(dtBegin.getDate() - 7)
let dtEnd = dtBegin

if (parseInt(localStorage.getItem('org_id')) === 2) {
    let year = new Date().getFullYear()
    let lastYear = year - 1
    dtEnd = new Date(String(lastYear) + '-12-30')
    dtBegin = new Date(String(lastYear) + '-01-01')
}

const state = {
    timePeers: 'Time',
    stores: [],
    period: 'week',
    numberOfPeriods: 8,
    performancePeriod: { 'begin': dtBegin, 'end': dtEnd },
    performanceType: 'Budget',
    contractsSwitch: 'Total',
    productivitySwitch: 'Prod',
    zoomedInStores: [],
    contractsTop5Switch: 'Contracts',
    performanceStoreWeek: 'Store',
    performanceKPI: 'KPI',
    powerhoursSwitch: 'Prod',
    powerhoursSelectedStore: null
}

const mutations = {
    'UPDATE_TIMEPEERS' (state, payload) {
        vue.set(state, 'timePeers', payload)
    },
    'UPDATE_STORES' (state, payload) {
        vue.set(state, 'stores', payload.stores)
        if (payload.initialLoad === true) {
            vue.set(state, 'zoomedInStores', [payload.stores[0]])
        } else {
            vue.set(state, 'zoomedInStores', payload.stores)
        }
    },
    'UPDATE_ZOOMED_STORES' (state, payload) {
        vue.set(state, 'zoomedInStores', payload)
    },
    'RESET_ZOOMED_STORES' (state, payload) {
        vue.set(state, 'zoomedInStores', state.stores)
    },
    'UPDATE_CONTRACTS_SWITCH' (state, payload) {
        vue.set(state, 'contractsSwitch', payload)
    },
    'UPDATE_CONTRACTS_TOP5_SWITCH' (state, payload) {
        vue.set(state, 'contractsTop5Switch', payload)
    },
    'UPDATE_PRODUCTIVITY_SWITCH' (state, payload) {
        vue.set(state, 'productivitySwitch', payload)
    },
    'UPDATE_PERIOD' (state, payload) {
        vue.set(state, 'period', payload)
    },
    'UPDATE_NUMBER_OF_PERIODS' (state, payload) {
        vue.set(state, 'numberOfPeriods', payload)
    },
    'UPDATE_PERFORMANCE_PERIOD' (state, payload) {
        vue.set(state.performancePeriod, payload.type, payload.value)
    },
    'UPDATE_PERFORMANCE_TYPE' (state, payload) {
        vue.set(state, 'performanceType', payload)
    },
    'UPDATE_PERFORMANCE_STORE_WEEK_TYPE' (state, payload) {
        vue.set(state, 'performanceStoreWeek', payload)
    },
    'UPDATE_PERFORMANCE_KPI' (state, payload) {
        vue.set(state, 'performanceKPI', payload)
    },
    'SET_POWER_HOURS_SELECTED_STORE' (state, payload) {
        vue.set(state, 'powerhoursSelectedStore', payload)
    }

}

const actions = {
    updateStores: ({ commit, rootState }, payload) => {
        let selectedStores = []
        let initial = Object.keys(payload).includes('initialLoad')
        if (Object.keys(payload).includes('stores')) {
            for (let store of rootState.general.stores) {
                if (payload.stores.includes(store.store_id)) {
                    selectedStores.push(store)
                }
            }
        }
        commit('UPDATE_STORES', { 'stores': selectedStores, 'initialLoad': initial })
    }
}

const getters = {
    getSelectedStores: state => { return state.stores },
    storesLoaded: state => { return state.stores.length > 0 },
    getStoreIds: state => { return state.stores.map(store => store.store_id) },
    getZoomedinStores: state => { return state.zoomedInStores.map(store => store.store_id) },
    getPeriod: state => { return state.period },
    getNumberOfPeriods: state => { return parseInt(state.numberOfPeriods) }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
